"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("../config"));
function initProfileUpdate(request) {
    return rest_1.httpPost(config_1.default.profileAPI().endPoint() + "change-request/contact", request);
}
exports.initProfileUpdate = initProfileUpdate;
function completeProfileUpdate(requestId, request) {
    return rest_1.httpPost(config_1.default.profileAPI().endPoint() + ("change-request/" + requestId + "/process"), request);
}
exports.completeProfileUpdate = completeProfileUpdate;
function verifyEmailCode(code) {
    return rest_1.httpPost(config_1.default.profileAPI().endPoint() + "change-request/process", { requestId: code });
}
exports.verifyEmailCode = verifyEmailCode;
